import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from '../shared/services/api.service';
import { LocalAccountService } from '../shared/services/localAccount.service';
import { SalesPackage } from '../models/salespackage/salespackage.model';
import { Softskill } from '../models/softskill/softskill.model';


@Injectable({
  providedIn: 'root'
})
export class SoftskillService implements Resolve<any> {

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if ((state.url.includes('common-area') && state.url.includes('/softskills-offer') && state.url.includes('/detail')) ||
      (state.url.includes('common-area') && state.url.includes('/softskills-offer'))
    ) {
      try {
        const resolved: any = {};
        let subscriptionResponse: any;
        if (this.localAccountService.isAdmin() || this.localAccountService.isOperator()) {
          // subscriptionResponse = await this.getSubscription(route.params.subscriptionId);
        } else {
          subscriptionResponse = await this.getSoftskillAllowed(null, null);
        }
        resolved.softskills = subscriptionResponse.payload;
        if (route.params) {
          if (route.params.softskillId) {
            const subjectResponse: any = await this.getSoftskillAllowedById(route.params.softskillId);
            resolved.softskill = subjectResponse.payload;
          }
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else {
      try {
        const resolved: any = {};
        // if (route.params.degreeCourseId == 'new') {
        //   return resolved;
        // } else {
        // const degreeCourseResponse: any = await this.getDegreeCourse(route.params.degreeCourseId);
        // resolved.degreeCourse = degreeCourseResponse.payload;
        if (route.params.softskillId && !(route.params.softskillId === 'new')) {
          const subjectResponse: any = await this.getSoftskill(route.params.softskillId);
          resolved.softskill = subjectResponse.payload;
        }
        return resolved;
        // }
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }
  }

  constructor(private api: ApiService, private localAccountService: LocalAccountService, private router: Router) {

  }

  retrieveSoftskills(filterString, filterSoftskillCategoryId, pageIndex, pageSize, sortField, sortDirection) {
    if (!filterString) {
      filterString = ''
    };
    if (!pageIndex) {
      pageIndex = 0
    }
    if (!pageSize) {
      pageSize = 10
    }
    return this.api.getRequestPromise(`softskill/paged?filterString=${filterString}&filterSoftskillCategoryId=${filterSoftskillCategoryId}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`);
  }

  getSoftskills() {
    return this.api.getRequestPromise("softskill/list");
  }

  deactivateSoftskill(id) {
    return this.api.putRequestPromise(`softskill/${id}/deactivate`, {});
  }

  associateSoftskill(id) {
    return this.api.postRequestPromise(`softskill/${id}/associate`, {});
  }

  dissociateSoftskill(id) {
    return this.api.deleteRequestPromise(`softskill/${id}/dissociate`);
  }

  activateSoftkill(id) {
    return this.api.putRequestPromise(`softskill/${id}/activate`, {});
  }

  deleteSoftkill(id) {
    return this.api.deleteRequestPromise(`softskill/${id}/delete`);
  }

  async getSoftskill(id) {
    return this.api.getRequestPromise(`softskill/${id}`);
  }

  async createSoftskill(obj) {
    return this.api.postRequestPromise(`softskill`, obj);
  }

  async editSoftskill(obj) {
    return this.api.putRequestPromise(`softskill`, obj);
  }

  async getSoftskillAllowed(filterString, filterSoftskillCategoryId) {
    if (!filterString) {
      filterString = ''
    };
    if (!filterSoftskillCategoryId) {
      filterSoftskillCategoryId = ''
    };
    // return this.api.getRequestPromise(`public/wp/softskills?filterString=${filterString}&softskillCategoryId=${filterSoftskillCategoryId}`);
    return this.api.getRequestPromise(`public/softskills?filterString=${filterString}&softskillCategoryId=${filterSoftskillCategoryId}`);
  }

  getSoftskillsForEstimation(softskillCategoryId) {
    return this.api.getRequestPromise(`softskill/list/${softskillCategoryId}/forEstimation`);
  }

  getTeachSoftskills(filterString, filterSoftskillCategoryId, pageIndex, pageSize, sortField, sortDirection) {
    if (!filterString) {
      filterString = ''
    };
    if (!pageIndex) {
      pageIndex = 0
    }
    if (!pageSize) {
      pageSize = 10
    }
    return this.api.getRequestPromise(`softskill/thaught/paged?filterString=${filterString}&filterSoftskillCategoryId=${filterSoftskillCategoryId}&pageIndex=${pageIndex}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`);
  }

  getAllowedSoftskillsByCategoryId(softskillCategoryId) {
    return this.getSoftskillAllowed(null, softskillCategoryId);
  }

  async getSoftskillAllowedById(id) {
    // return this.api.getRequestPromise(`public/wp/softskill/${id}`);
    return this.api.getRequestPromise(`public/softskill/${id}`);
  }

  retrieveSoftskillColor(softskill: Softskill) {
    let ret;
    ret = softskill.defaultAgendaColor;
    if (!ret) {
      ret = '#3c4252';
    }
    return ret;
  }

  retrieveSoftskillImageUrl(softskill: Softskill) {
    let ret;
    if (softskill.imageUrl) {
      ret = softskill.imageUrl;
    } else {
      ret = '/assets/images/exellente/placeholder_softskill_card.jpg';
    }
    return ret;
  }

}
